import { render, staticRenderFns } from "./CoachesPage.vue?vue&type=template&id=35b04e20&"
import script from "./CoachesPage.vue?vue&type=script&lang=js&"
export * from "./CoachesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports